import { render, staticRenderFns } from "./SubMenuTab_ContractOrders.vue?vue&type=template&id=7ed3dc7f&scoped=true&"
import script from "./SubMenuTab_ContractOrders.vue?vue&type=script&lang=js&"
export * from "./SubMenuTab_ContractOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed3dc7f",
  null
  
)

export default component.exports